import { useEffect, useSyncExternalStore } from 'react';
import { isIOS } from './iosLayout';

let hideCount = 0;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function hiddenNow() {
  return hideCount > 0;
}

/** True while any iPhone screen has asked to hide the tab bar. */
export function useBottomNavHidden() {
  return useSyncExternalStore(subscribe, hiddenNow, () => false);
}

/**
 * Hide the tab bar and Scan bubble while `active` is true.
 * Only takes effect on iPhone and iPad. Other devices are unchanged.
 */
export function useHideBottomNav(active) {
  useEffect(() => {
    if (!active || !isIOS()) return undefined;
    hideCount += 1;
    notify();
    return () => {
      hideCount = Math.max(0, hideCount - 1);
      notify();
    };
  }, [active]);
}
